export default {
      id: "ic-plan-stationnement-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-stationnement-usage",
      toString: function () {
        return this.url;
      }
    }